import { getCsrfToken } from "@/app/_utils/csrf";

export interface FormRequest {
  id: number;
  name: string | null;
  email: string;
  phone_number: string | null;
  comment: string | null;
  form_type: "contact_us" | "work_with_us";
  status: "new" | "accepted" | "declined";
  created_at: string;
}

class ContactService {
  static instance: ContactService;
  csrfToken = getCsrfToken();
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

  async getContactUs(): Promise<FormRequest[]> {
    const res = await fetch(`${this.baseUrl}form/`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.json();
  }

  async contactUs(data: any) {
    return fetch(`${this.baseUrl}form/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        // Anonymous submitters carry no csrftoken and SessionAuthentication skips the
        // check for them. This is for the logged-in-admin case, where the session
        // cookie does authenticate and CSRF is then enforced.
        "X-CSRFToken": this.csrfToken,
      },
    });
  }

  async updateStatus(id: number, status: FormRequest["status"]): Promise<FormRequest> {
    const res = await fetch(`${this.baseUrl}form/${id}/status/`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });
    return res.json();
  }
}

export default new ContactService();
